export const getGroupsBySubcategory = (subcategoryId, cities = []) => {
    console.log("Fetching groups for subcategoryId:", subcategoryId);
  
    // Normalize subcategoryId (convert to lowercase if it's a string)
    const normalizedSubcategoryId = isNaN(subcategoryId)
      ? subcategoryId.toLowerCase()
      : Number(subcategoryId);
  
    let groups = [];

    // Map numeric subcategory IDs to string keys
  const subcategoryIdMap = {
    201: "residential",
    202: "commercial",
    203: "land",
    204: "multiple-units",

    //property-for-rent
    301: "residential",
    302: "commercial",
    303: "rooms-for-rent",
    304: "monthly-short-term",
    305: "daily-short-term",
  };
  
    // If the subcategoryId is numeric, map it to its string key
    const mappedSubcategoryId =
    typeof normalizedSubcategoryId === "number"
      ? subcategoryIdMap[normalizedSubcategoryId]
      : normalizedSubcategoryId;

      
    // Define groups for Motors
    const motorsGroups = {
      102: [ // Motorcycles
        { id: 201, name: "Sport Bike", hasSection: true, sections: ["Hyper Sports", "Super Bike", "Super Sports"] },
        { id: 202, name: "Adventure / Touring", hasSection: false },
        { id: 203, name: "Cruiser / Chopper", hasSection: false },
        { id: 204, name: "Off-Road", hasSection: false },
        { id: 205, name: "Scooter", hasSection: false },
        { id: 206, name: "Standard / Commuter", hasSection: false },
        { id: 207, name: "Cafe Racer", hasSection: false },
        { id: 208, name: "Trike", hasSection: false },
        { id: 209, name: "Trailer", hasSection: false },
        { id: 210, name: "Karting", hasSection: false },
        { id: 211, name: "Mo-Ped", hasSection: false },
        { id: 212, name: "Golf Cart", hasSection: false },
        { id: 213, name: "Other", hasSection: false },
      ],
      103: [ // Auto Accessories & Parts
        { id: 301, name: "Car 4x4 Parts", hasSection: true, sections: ["A/C & Heating Parts", "Batteries", "Brakes", "Engine & Computer Parts", "Exhaust/Air Intake", "Exterior Parts", "Interior Parts", "Lighting", "Suspension", "Wheels/Tires", "Other"] },
        { id: 302, name: "Apparel, Merchandise & Accessories", hasSection: true, sections: ["Apparel", "Boat Accessories", "Car/4x4 Accessories", "Merchandise", "Motorcycle Accessories", "Other"] },
        { id: 303, name: "Motorcycle Parts", hasSection: true, sections: ["Accessories", "Body & Frame", "Brakes & Suspension", "Engines & Components", "Lighting", "Wheels Tires", "Other"] },
        { id: 304, name: "Automotive Tools", hasSection: true, sections: ["Tool Accessories", "Tool Sets", "Tools"] },
        { id: 305, name: "Boat Parts", hasSection: true, sections: ["Body Parts & Accessories", "Electronic Parts", "Engine Parts", "Plumbing & Ventilation", "Sailing Gear", "Other"] },
        { id: 306, name: "Other Vehicle Parts", hasSection: false },
      ],
      104: [ // Heavy Vehicles
        { id: 401, name: "Trucks", hasSection: true, sections: ["Cab-Chassis", "Cherry Picker", "Crane Truck", "Curtain Sider", "Dual Cab", "Fire Truck", "Other", "Primer Mover", "Refrigerated Truck", "Service Vehicle", "Tipper", "Tow & Tilt", "Wrecking"] },
        { id: 402, name: "Buses", hasSection: true, sections: ["City Bus", "Coach", "Coaster", "School Bus", "Other"] },
        { id: 403, name: "Forklifts", hasSection: true, sections: ["All Terrain", "Diesel", "Electric", "Side Loader", "Other"] },
        { id: 404, name: "Trailers", hasSection: true, sections: ["B Double", "Camping Trailer", "Curtain Sider", "Dog Trailer", "Dolly Trailer", "Drop Decker", "Drop Decker", "Extendable Trailer", "Flat Deck", "Low Loader", "Other", "Refrigerated Trailer", "Tipper"] },
        { id: 405, name: "Cranes", hasSection: true, sections: ["All Terrain Cranes", "Tower Cranes", "Tractor Cranes", "Truck Loading", "Other"] },
        { id: 406, name: "Tankers", hasSection: true, sections: ["Fiberglass Tank", "Fuel Tank", "Stainless Steel Tank", "Water Tank"] },
        { id: 407, name: "Parts & Engines", hasSection: true, sections: ["Bus Parts", "Crane Parts", "Forklift Parts", "Trailer Parts", "Tanker Parts", "Truck Parts", "Other Parts"] },
        { id: 408, name: "Aircrafts", hasSection: false },
        { id: 409, name: "Other Heavy Vehicles", hasSection: true, sections: ["Agriculture Vehicles", "Excavator", "Road Roller", "RVs & Motorhomes", "Site Dumpers", "Sweepers", "Tractors", "Wheel Loader", "Winches"] },
      ],
      105: [ // Boats
        { id: 501, name: "Motorboats", hasSection: true, sections: ["Cabin Cruiser Boat", "Cruiser Boat", "Fishing Boat", "Outboard Dayboat", "Pontoon/House Boat", "Racing Boat", "Sleeper/Mini Yacht", "Wakeboarding/Ski Boat", "Yacht", "Other"] },
        { id: 502, name: "Sailboats", hasSection: true, sections: ["Catamaran", "Cruiser/Day Sailor", "DhowVoiier", "Dinghy", "Racer", "Sailing Yacht", "Other"] },
        { id: 503, name: "Row/Paddle Boats", hasSection: true, sections: ["Canoe/Row Boat", "Paddle Boat", "Other"] },
      ],
      106: cities.map((city, index) => ({ // Number Plates
        id: 600 + index + 1,
        name: city.name,
        hasSection: true,
        sections: ["Private Car", "Classic Car", "Motorcycle"],
      })),
    };
  
    // Define groups for Property for Sale
    const propertyForSaleGroups = {
      residential: [
        { id: 1, name: "Apartment", hasSection: false },
        { id: 2, name: "Villa", hasSection: false },
        { id: 3, name: "TownHouse", hasSection: false },
        { id: 4, name: "PentHouse", hasSection: false },
        { id: 5, name: "Residential Building", hasSection: false },
        { id: 6, name: "Residential Floor", hasSection: false },
        { id: 7, name: "Villa Compound", hasSection: false },
      ],
      commercial: [
        { id: 8, name: "Office", hasSection: false },
        { id: 9, name: "Retail", hasSection: false },
        { id: 10, name: "Industrial", hasSection: false },
        { id: 11, name: "Staff Accommodation", hasSection: false },
        { id: 12, name: "Shop", hasSection: false },
        { id: 13, name: "Warehouse", hasSection: false },
        { id: 14, name: "Commercial Floor", hasSection: false },
        { id: 15, name: "Commercial Building", hasSection: false },
        { id: 16, name: "Commercial Villa", hasSection: false },
        { id: 17, name: "Factory", hasSection: false },
        { id: 18, name: "Other", hasSection: false },
        { id: 19, name: "Showroom", hasSection: false },
      ],
      land: [],
      "multiple-units": [],
    };

    // Define groups for Property for Rent
  const propertyForRentGroups = {
    residential: [
      { id: 1, name: "Apartment", hasSection: false },
      { id: 2, name: "Villa", hasSection: false },
      { id: 3, name: "Townhouse", hasSection: false },
      { id: 4, name: "Penthouse", hasSection: false },
      { id: 5, name: "Residential Building", hasSection: false },
      { id: 6, name: "Villa Compound", hasSection: false },
      { id: 7, name: "Residential Floor", hasSection: false },
    ],
    commercial: [
      { id: 8, name: "Office", hasSection: false },
      { id: 9, name: "Industrial", hasSection: false },
      { id: 10, name: "Retail", hasSection: false },
      { id: 11, name: "Staff Accommodation", hasSection: false },
      { id: 12, name: "Shop", hasSection: false },
      { id: 13, name: "Warehouse", hasSection: false },
      { id: 14, name: "Commercial Floor", hasSection: false },
      { id: 15, name: "Commercial Villa", hasSection: false },
      { id: 16, name: "Other", hasSection: false },
      { id: 17, name: "Bulk Unit", hasSection: false },
      { id: 18, name: "Commercial Plot", hasSection: false },
      { id: 19, name: "Factory", hasSection: false },
      { id: 20, name: "Industrial Land", hasSection: false },
      { id: 21, name: "Mixed Use Land", hasSection: false },
      { id: 22, name: "Showroom", hasSection: false },
      { id: 23, name: "Commercial Building", hasSection: false },
    ],
    "rooms-for-rent": [
      { id: 24, name: "Apartment", hasSection: false },
      { id: 25, name: "Villa", hasSection: false },
    ],
    "monthly-short-term": [
      { id: 26, name: "Apartment", hasSection: false },
      { id: 27, name: "Villa", hasSection: false },
    ],
    "daily-short-term": [
      { id: 28, name: "Apartment", hasSection: false },
      { id: 29, name: "Villa", hasSection: false },
    ],
  };
  

  
  // Define groups for Jobs
  const jobsGroups = {
    412: [ // Engineering
      { id: 1, name: "Civil Engineering", hasSection: false },
      { id: 2, name: "Electric Engineering", hasSection: false },
      { id: 3, name: "Mechanical Engineering", hasSection: false },
      { id: 4, name: "Others - Engineering", hasSection: false },
      { id: 5, name: "Software Engineering", hasSection: false },
    ],
    416: [ // Information Technology
      { id: 6, name: "Hardware Development", hasSection: false },
      { id: 7, name: "Others", hasSection: false },
      { id: 8, name: "Software Development", hasSection: false },
      { id: 9, name: "System Administration", hasSection: false },
      { id: 10, name: "Web Development", hasSection: false },
    ],
  };
    // Determine groups based on subcategoryId
  if (motorsGroups[normalizedSubcategoryId]) {
    groups = motorsGroups[normalizedSubcategoryId];
  } else if (propertyForSaleGroups[mappedSubcategoryId]) {
    groups = propertyForSaleGroups[mappedSubcategoryId];
  } 
  else if (propertyForRentGroups[mappedSubcategoryId]) {
    groups = propertyForRentGroups[mappedSubcategoryId];
  }
  // Add logic to return groups for Jobs subcategories
  if (jobsGroups[normalizedSubcategoryId]) {
    groups = jobsGroups[normalizedSubcategoryId];
  } 
  else {
    console.error("Unknown subcategoryId:", subcategoryId);
  }
  
    return groups;
  };